import { action, computed, makeObservable, observable } from 'mobx';
import React from 'react';
import { Validator } from 'shared/validators/Index';

export class FormField {
    @observable public name: string;
    @observable public value: any;
    @observable public error: string | null | undefined;

    public validators: Validator[] = [];
    public prevValue: any;
    public isChanged: boolean = false;
    public controlRef: React.RefObject<any> | undefined;

    constructor(
        name: string,
        value: any = undefined,
        validators: Validator[] = []
    ) {
        this.name = name;
        this.value = value;
        this.validators = validators;

        makeObservable(this);
    }

    @action
    init(value: any) {
        this.value = value;
    }

    @action
    reset() {
        this.value = Array.isArray(this.value) ? [] : null;
        this.resetState();
    }

    @action
    resetState() {
        this.isChanged = false;
        this.prevValue = null;
        this.error = null;
    }

    @action
    setValue(value: any) {
        this.prevValue = this.value;
        this.value = value;
        this.isChanged = true;

        this.validate(value);
    }

    addValidator(validator: Validator) {
        this.validators.push(validator);
    }

    setValidators(validators: Validator[]) {
        this.validators = validators || [];
    }

    setNewRef() {
        this.controlRef = React.createRef();
    }

    @action
    setError(error: string) {
        this.error = error;
    }

    @action
    validate(formSubmit: boolean = false) {
        const validationResult = this.validators
            .filter(
                (x) =>
                    !x.options.validateOnlyOnSubmit ||
                    x.options.validateOnlyOnSubmit === formSubmit
            )
            .map((validator) => validator.validate(this.value))
            .find((e) => e.hasError);
        if (validationResult && validationResult.hasError) {
            this.error = validationResult.errorMessage;
        } else {
            this.error = null;
        }
    }
    focus() {
        if (this.ref && this.ref.current) {
            if (this.ref.current.focus) {
                this.ref.current.focus();
            } else if (this.ref.current.inputElement) {
                this.ref.current.inputElement.focus();
            }
        }
    }

    @computed
    get hasError() {
        return !!this.error;
    }

    @computed
    get hasValue() {
        if (Array.isArray(this.value)) {
            return this.value.length > 0;
        }
        return this.value != null;
    }

    get ref() {
        if (!this.controlRef) {
            this.setNewRef();
        }
        return this.controlRef;
    }
}
